import { render, staticRenderFns } from "./TechInfoContainer.vue?vue&type=template&id=88d6fade&scoped=true&"
import script from "./TechInfoContainer.vue?vue&type=script&lang=js&"
export * from "./TechInfoContainer.vue?vue&type=script&lang=js&"
import style0 from "./TechInfoContainer.vue?vue&type=style&index=0&id=88d6fade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d6fade",
  null
  
)

export default component.exports